import React from 'react';
import Link from 'gatsby-link';
import Card from '../components/Card';
import staticdata from '../../staticdata.json';
import Section from '../components/Section.js';
import Wave from '../components/Wave';
import Cell from '../components/Cell';

// BUG-FOUND: you have to parse your JSON staticdata into array by JSON.parse
//const data = JSON.parse(staticdata);

// BUG-FOUND: 上面说的是错的，因为少了return，加上return就可以render了

const IndexPage = () => (
  <div>
    <div className="Hero">
      <div className="HeroGroup">
        <div className="SpaceBoxOne" ></div>
        <p>Hi there, my name is</p>
        <h1>Mary Quan<br /></h1>
        <div className="SpaceBoxOne" ></div>
        <p>I'm a full stack developer with perference in front-end techs and designs. Also passionate about iOS dev with Swift and SwiftUI. Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>

        <div className="SpaceBoxTwo" ></div>

        <a href="">Download My Resume</a>

        <Wave />
      </div>
    </div>

    <div className="Cards">
      <h2>Lorem Ipsum</h2>
      <div className="CardGroup">
        <Card title="Project One" text="React + Node" image={`../images/wallpaper.jpg`}/>
        <Card title="Project Two" text="AWS" image={`../images/wallpaper2.jpg`}/>
        <Card title="Project Three" text="Swift + SwiftUI" image={`../images/wallpaper3.jpg`}/>
      </div>
    </div>

    
    <Section 
      image="https://p75.tr0.n0.cdn.getcloudapp.com/items/9ZuR6lQk/ca52c0e0-7e32-4d59-8195-1120695dc766.png?v=f583376540de4c1d343544faff2a6714"
      logo="https://p75.tr0.n0.cdn.getcloudapp.com/items/v1ujqWAX/010d0069-f670-4bb2-8e2b-016dff96260f.svg?v=97bbc4c955facc74c52f11c86a534368"
      title="About mquan.io"
      text="Client side was developed using Gatsby.js, server side was developed using Node.js, and Amazong Web Service (AWS) was used for storage and deployment."
    />

    <div className="SectionCaption">
      <p>12 sections - 6 hours</p>
    </div>
    <div className="SectionCellGroup">
      {staticdata.cells.map( cell => {
        return <Cell title={cell.title} image={cell.image} />
      })}
    </div>
  </div>
)

export default IndexPage


// WEBPACK FOOTER //
// ./src/pages/index.js